$(() => {
  if ($(window).width() >= 768) {
    return
  }

  const $btn = $("[data-table=btn]")
  const $list = $("[data-table=list]")
  const $item = $("[data-table-item]")
  const $cell = $("[data-table-cell]")

  const toggleList = () => {
    $btn.toggleClass("_is-clicked")
    $list.toggleClass("_is-opened")
  }

  const renameCells = (item) => {
    const $currentItem = item.attr("data-table-item")
    const $currentCells = $("[data-table-cell =" + $currentItem + "]")

    $btn.text(item.text())

    $cell.each((index, element) => $(element).addClass("_is-hidden"))

    $currentCells.each((index, element) => $(element).removeClass("_is-hidden"))
  }

  $btn.on("click", toggleList)

  $item.on("click", (event) => {
    const $self = $(event.currentTarget)

    $item.removeClass("_is-selected")
    $self.addClass("_is-selected")
    renameCells($self)
    toggleList()
  })
})



// WEBPACK FOOTER //
// ./src/blocks/08.staple-token/staple-token.js